import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../helpers/Requests'
import DirectoryBackground from '../images/directory_background.jpg';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

class Directory extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  state = {
    locations: [],

    search: null,
    searchedTerm: null,

    loaded: false,
    error: null
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  clearSearch(event) {
    this.setState({"search": ""});

    this.fetchData(null)
  }

  handleSearch(event) {
    const search = this.state.search

    if (search === null || search === "") {
      this.props.history.push(`/directory`)
    }
    else {
      this.props.history.push(`/directory?search=${this.state.search}`)
    }

    this.setState({
      loaded: false,
      searchedTerm: search
    })

    this.fetchData(this.state.search)

    event.preventDefault()
  }

  fetchData(searchTerm) {
    let params = ""

    if (searchTerm !== null) {
      params = `?near=${searchTerm}`
    }

    request('GET', `/v1/b/directory${params}`)
      .then(data => {
        this.setState({ locations: data, loaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, loaded: true })
      })
  }

  backgroundImage(background_image) {
    if (background_image !== null) {
      return (
        `url(${process.env.REACT_APP_ROOT_DOMAIN}/${background_image})`
      );
    }
  }

  locationWidget(location) {
    let address = []
    if (location.address) {
      address.push(location.address.split("\n")[0].split(",")[0].trim())
    }
    if (location.postcode) {
      address.push(location.postcode)
    }
    address = address.join(", ")

    return (
      <div className="widget locations-page full-background" style={{ backgroundImage: this.backgroundImage(location.background_image), borderColor: location.border_color }} key={location.id}>
        <div className="fade">
          <h3 className="title hover-text">{location.name}</h3>

          <div className="text">
            <div className="address hover-text">
              {address}
            </div>
            <div className="second-row">
              <div className="phone hover-text">
                {location.phone}
              </div>
              {location.direction !== null ? (
                <div className="distance hover-text">
                  {location.distance} miles <div className="direction">{this.locationDirection(location.direction)}</div>
                </div>
              ) : (null)}
            </div>
          </div>

        </div>
      </div>
    )
  }

  locationDirection(direction) {
    switch(direction) {
      case "N":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(0deg)"}} />
      case "NE":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(45deg)"}} />
      case "E":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(90deg)"}} />
      case "SE":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(135deg)"}} />
      case "S":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(180deg)"}} />
      case "SW":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(225deg)"}} />
      case "W":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(270deg)"}} />
      case "NW":
        return <FontAwesomeIcon icon={faArrowUp} style={{transform: "rotate(315deg)"}} />
      default:
        return null
    }
  }

  render() {
    const { locations, search, searchedTerm, loaded, error } = this.state;

    if (error) {
      return (
        <div className="error">{error.message}</div>
      )
    }

    return (
      <div className="background-image directory" style={{ backgroundImage: `url(${DirectoryBackground})` }}>
        <Link to={"/directory"} onClick={this.clearSearch}>
          <div className="directory-header">
            <div>Digital Reception's</div>
            <div className="title">Directory <span className="tiny">of</span> Salons</div>
          </div>
        </Link>

        <form className="directory-header" onSubmit={this.handleSearch}>
          <input className="input-box" type="text" placeholder="Enter postcode or area..." name="search" value={search} onChange={this.handleChange} />
          <button className="button" target="service">Search</button>
        </form>

        {loaded === false ? (
          <div className="directory-header">
            <p>Loading ...</p>
          </div>
        ) : (
          <>
            {locations.length === 0 ? (
              <div className="directory-header">
                No Locations found for {searchedTerm}.
              </div>
            ) : (null)}
            <div className="widgets">
              {locations.map((location) => (
                this.locationWidget(location)
              ))}
            </div>
          </>
        )}
      </div>
    )
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search)
    const search = params.get("search")

    this.setState({
      "search": search,
      "searchedTerm": search // A static value for "No results" messages
    })

    this.fetchData(search)
  }
}

export default Directory;
